export { carePlanTriggers } from '../en/care-plan-triggers';
